import React from 'react';

import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import TracklogMenu from 'ff/debrief/components/menu/TracklogMenu';

const InfoMenu = () => {
    const anchorElRef = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);

    const handleKebabClick = () => {
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <IconButton
                ref={anchorElRef}
                color="secondary"
                onClick={handleKebabClick}
            >
                <MoreHorizIcon sx={{ color: '#000000' }} />
            </IconButton>
            <Menu
                anchorEl={anchorElRef.current}
                onClose={handleClose}
                open={isOpen}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <TracklogMenu onMenuItemClick={handleClose} />
            </Menu>
        </div>
    );
};

export default InfoMenu;
